import { ShapeArrowLeft } from "@/shapeStorage/shapes/basic/arrowLeft";
import { ShapeArrowLeftRight } from "@/shapeStorage/shapes/basic/arrowLeftRight";
import { ShapeArrowRight } from "@/shapeStorage/shapes/basic/arrowRight";
import { ShapeBraceLeft } from "@/shapeStorage/shapes/basic/braceLeft";
import { ShapeBraceRight } from "@/shapeStorage/shapes/basic/braceRight";
import { ShapeBubble } from "@/shapeStorage/shapes/basic/bubble";
import { ShapeCircle } from "@/shapeStorage/shapes/basic/circle";
import { ShapeCross } from "@/shapeStorage/shapes/basic/cross";
import { ShapeDownTriangle } from "@/shapeStorage/shapes/basic/downTriangle";
import { ShapeHexagon } from "@/shapeStorage/shapes/basic/hexagon";
import { ShapeLSkewRect } from "@/shapeStorage/shapes/basic/LSkewRect";
import { ShapeOctagon } from "@/shapeStorage/shapes/basic/octagon";
import { ShapePentagon } from "@/shapeStorage/shapes/basic/pentagon";
import { ShapeRSkewRect } from "@/shapeStorage/shapes/basic/RSkewRect";
import { ShapeRect } from "@/shapeStorage/shapes/basic/rect";
import { ShapeRombus } from "@/shapeStorage/shapes/basic/rombus";
import { ShapeRoundedRect } from "@/shapeStorage/shapes/basic/roundedRect";
import { ShapeTrapezoid } from "@/shapeStorage/shapes/basic/trapezoid";
import { ShapeTriangle } from "@/shapeStorage/shapes/basic/triangle";
import { ShapeGateWay } from "@/shapeStorage/shapes/bpmn/gateWay";
import { ShapeStartEvent } from "@/shapeStorage/shapes/bpmn/startEvent";
import { ShapeTask } from "@/shapeStorage/shapes/bpmn/task";
import { ShapeDatabase } from "@/shapeStorage/shapes/flowchart/database";
import { ShapeDelay } from "@/shapeStorage/shapes/flowchart/delay";
import { ShapeDirectAccessStorage } from "@/shapeStorage/shapes/flowchart/directAccessStorage";
import { ShapeDisplay } from "@/shapeStorage/shapes/flowchart/display";
import { ShapeDocument } from "@/shapeStorage/shapes/flowchart/document";
import { ShapeInternalStorage } from "@/shapeStorage/shapes/flowchart/internalStorage";
import { ShapeManualInput } from "@/shapeStorage/shapes/flowchart/manualInput";
import { ShapeManualOperation } from "@/shapeStorage/shapes/flowchart/manualOperation";
import { ShapeMerge } from "@/shapeStorage/shapes/flowchart/merge";
import { ShapeOffPageConnector } from "@/shapeStorage/shapes/flowchart/offPageConnector";
import { ShapeOr } from "@/shapeStorage/shapes/flowchart/or";
import { ShapeStoredData } from "@/shapeStorage/shapes/flowchart/storedData";
import { ShapeActivity } from "@/shapeStorage/shapes/uml/activity";
import { ShapeCollaboration } from "@/shapeStorage/shapes/uml/collaboration";
import { ShapeEnd } from "@/shapeStorage/shapes/uml/end";
import { ShapeHistoryPseudoState } from "@/shapeStorage/shapes/uml/historyPseudoState";
import { ShapeInterface } from "@/shapeStorage/shapes/uml/interface";
import { ShapeNode } from "@/shapeStorage/shapes/uml/node";
import { ShapePin } from "@/shapeStorage/shapes/uml/pin";
import { ShapePinFilledRight } from "@/shapeStorage/shapes/uml/pinFilledRight";
import { ShapePinRight } from "@/shapeStorage/shapes/uml/pinRight";
import { ShapeReceiveSignal } from "@/shapeStorage/shapes/uml/receiveSignal";
import { ShapeSendSignal } from "@/shapeStorage/shapes/uml/sendSignal";
import { ShapeStart } from "@/shapeStorage/shapes/uml/start";
import { ShapeUseCase } from "@/shapeStorage/shapes/uml/usecase";
import { ShapeCloud } from "./shapes/basic/cloud";
import { ShapePredefinedProcess } from "./shapes/basic/predefinedProcess";
import { ShapeStar } from "./shapes/basic/star";
import { ShapeCallActivity } from "./shapes/bpmn/callActivity";
import { ShapeDataObject } from "./shapes/bpmn/dataObject";
import { ShapeDataStore } from "./shapes/bpmn/dataStore";
import { ShapeEndEvent } from "./shapes/bpmn/endEvent";
import { ShapeEventSubProcess } from "./shapes/bpmn/eventSubProcess";
import { ShapeGroup } from "./shapes/bpmn/group";
import { ShapeIntermediateEvent } from "./shapes/bpmn/intermediateEvent";
import { ShapeIntermediateEventNonInterrupting } from "./shapes/bpmn/intermediateEventNonInterrupting";
import { ShapeMessage } from "./shapes/bpmn/message";
import { ShapePool } from "./shapes/bpmn/pool";
import { ShapeStartEventNonInterrupting } from "./shapes/bpmn/startEventNonInterrupting";
import { ShapeTransaction } from "./shapes/bpmn/transaction";
import { ShapeCurlyBraceAnnotationLeft } from "./shapes/flowchart/curlyBraceAnnotationLeft";
import { ShapeCurlyBraceAnnotationRight } from "./shapes/flowchart/curlyBraceAnnotationRight";
import { ShapeData } from "./shapes/flowchart/data";
import { ShapeDecision } from "./shapes/flowchart/decision";
import { ShapeDivided } from "./shapes/flowchart/divided";
import { ShapeHorizontalSwimlane } from "./shapes/flowchart/horizontalSwimlane";
import { ShapeLinedDocument } from "./shapes/flowchart/linedDocument";
import { ShapeLinedShaded } from "./shapes/flowchart/linedShaded";
import { ShapeMen } from "./shapes/flowchart/men";
import { ShapeMultipleDocuments } from "./shapes/flowchart/multipleDocuments";
import { ShapeNote } from "./shapes/flowchart/note";
import { ShapeNote2 } from "./shapes/flowchart/note2";
import { ShapePredefinedProcessFlowchart } from "./shapes/flowchart/predefinedProcessFlowchart";
import { ShapePreparation } from "./shapes/flowchart/preparation";
import { ShapeProcess } from "./shapes/flowchart/process";
import { ShapeRing } from "./shapes/flowchart/ring";
import { ShapeSummingJunction } from "./shapes/flowchart/summingJunction";
import { ShapeTerminator } from "./shapes/flowchart/terminator";
import { ShapeVerticalSwimlane } from "./shapes/flowchart/verticalSwimlane";
import { ShapActivation } from "./shapes/uml/activation";
import { ShapeAssembly } from "./shapes/uml/assembly";
import { ShapeDeletion } from "./shapes/uml/deletion";
import { ShapeHorizontalFork } from "./shapes/uml/horizontalFork";
import { ShapeHorizontalPool } from "./shapes/uml/horizontalPool";
import { ShapePerson } from "./shapes/uml/person";
import { ShapePinFilledLeft } from "./shapes/uml/pinFilledLeft";
import { ShapePinLeft } from "./shapes/uml/pinLeft";
import { ShapeProvidedInterface } from "./shapes/uml/providedInterface";
import { ShapeRequiredInterface } from "./shapes/uml/requiredInterface";
import { ShapeVerticalFork } from "./shapes/uml/verticalFork";
import { ShapeVerticalPool } from "./shapes/uml/verticalPool";

export class ShapeStorage {
    getShape(mode?: string) {
        if (!mode || !this.shapes[mode]) {
            console.error(`Фигуры ${mode} не существует`);

            return this.shapes.rect;
        }

        return this.shapes[mode];
    }

    getAllShapes() {
        return Object.keys(this.shapes);
    }

    needStroke(mode: string) {
        return this.getShape(mode).needStroke;
    }

    disableFill(mode: string) {
        return !this.getShape(mode).needFill;
    }

    getDefaultBorderDashType(mode: string) {
        return this.getShape(mode).defaultBorderDashType;
    }

    getDefaultBorderWidth(mode: string) {
        return this.getShape(mode).defaultBorderWidth;
    }

    getDefaultColor(mode: string) {
        return this.getShape(mode).defaultColor;
    }

    shapes = {
        rect: new ShapeRect(),
        circle: new ShapeCircle(),
        roundedRect: new ShapeRoundedRect(),
        rombus: new ShapeRombus(),
        triangle: new ShapeTriangle(),
        RSkewRect: new ShapeRSkewRect(),
        LSkewRect: new ShapeLSkewRect(),
        downTriangle: new ShapeDownTriangle(),
        bubble: new ShapeBubble(),
        arrowRight: new ShapeArrowRight(),
        arrowLeft: new ShapeArrowLeft(),
        arrowLeftRight: new ShapeArrowLeftRight(),
        pentagon: new ShapePentagon(),
        octagon: new ShapeOctagon(),
        hexagon: new ShapeHexagon(),
        predefinedProcess: new ShapePredefinedProcess(),
        trapezoid: new ShapeTrapezoid(),
        cross: new ShapeCross(),
        braceLeft: new ShapeBraceLeft(),
        braceRight: new ShapeBraceRight(),
        document: new ShapeDocument(),
        manualInput: new ShapeManualInput(),
        database: new ShapeDatabase(),
        directAccessStorage: new ShapeDirectAccessStorage(),
        internalStorage: new ShapeInternalStorage(),
        manualOperation: new ShapeManualOperation(),
        delay: new ShapeDelay(),
        storedData: new ShapeStoredData(),
        merge: new ShapeMerge(),
        or: new ShapeOr(),
        display: new ShapeDisplay(),
        offPageConnector: new ShapeOffPageConnector(),
        star: new ShapeStar(),
        cloud: new ShapeCloud(),
        process: new ShapeProcess(),
        terminator: new ShapeTerminator(),
        decision: new ShapeDecision(),
        linedDocument: new ShapeLinedDocument(),
        multipleDocuments: new ShapeMultipleDocuments(),
        data: new ShapeData(),
        preparation: new ShapePreparation(),
        conversation: new ShapePreparation(),
        gateWay: new ShapeGateWay(),
        linedShaded: new ShapeLinedShaded(),
        divided: new ShapeDivided(),
        horizontalSwimlane: new ShapeHorizontalSwimlane(),
        note: new ShapeNote(),
        summingJunction: new ShapeSummingJunction(),
        note2: new ShapeNote2(),
        verticalSwimlane: new ShapeVerticalSwimlane(),
        curlyBraceAnnotationRight: new ShapeCurlyBraceAnnotationRight(),
        curlyBraceAnnotationLeft: new ShapeCurlyBraceAnnotationLeft(),
        men: new ShapeMen(),
        task: new ShapeTask(),
        transaction: new ShapeTransaction(),
        eventSubProcess: new ShapeEventSubProcess(),
        callActivity: new ShapeCallActivity(),
        group: new ShapeGroup(),
        startEvent: new ShapeStartEvent(),
        pool: new ShapePool(),
        startEventNonInterrupting: new ShapeStartEventNonInterrupting(),
        intermediateEvent: new ShapeIntermediateEvent(),
        intermediateEventNonInterrupting: new ShapeIntermediateEventNonInterrupting(),
        endEvent: new ShapeEndEvent(),
        dataObject: new ShapeDataObject(),
        dataStore: new ShapeDataStore(),
        horizontalSwimlaneBpmn: new ShapeHorizontalSwimlane(),
        verticalSwimlaneBpmn: new ShapeVerticalSwimlane(),
        annotation: new ShapeNote2(),
        message: new ShapeMessage(),
        activity: new ShapeActivity(),
        interface: new ShapeInterface(),
        template: new ShapeEventSubProcess(),
        container: new ShapeLinedShaded(),
        containerDivided: new ShapeDivided(),
        classifier: new ShapePredefinedProcessFlowchart(),
        predefinedProcessFlowchart: new ShapePredefinedProcessFlowchart(),
        sendSignal: new ShapeSendSignal(),
        offPageLink: new ShapeOffPageConnector(),
        gateWayUml: new ShapeGateWay(),
        receiveSignal: new ShapeReceiveSignal(),
        package: new ShapeNote(),
        node: new ShapeNode(),
        useCase: new ShapeUseCase(),
        collaboration: new ShapeCollaboration(),
        start: new ShapeStart(),
        end: new ShapeEnd(),
        flowFinal: new ShapeSummingJunction(),
        historyPseudoState: new ShapeHistoryPseudoState(),
        pin: new ShapePin(),
        pinRight: new ShapePinRight(),
        pinFilledRight: new ShapePinFilledRight(),
        pinLeft: new ShapePinLeft(),
        pinFilledLeft: new ShapePinFilledLeft(),
        deletion: new ShapeDeletion(),
        horizontalFork: new ShapeHorizontalFork(),
        verticalFork: new ShapeVerticalFork(),
        activation: new ShapActivation(),
        horizontalPool: new ShapeHorizontalPool(),
        verticalPool: new ShapeVerticalPool(),
        assembly: new ShapeAssembly(),
        providedInterface: new ShapeProvidedInterface(),
        requiredInterface: new ShapeRequiredInterface(),
        ring: new ShapeRing(),
        person: new ShapePerson(),
    };
}
